import React from 'react';
import type { Service } from '../../../../../../shared/types/config';

interface CategoriesSpeItem {
  id: number;
  nom: string;
  id_service: number;
  ordre: number;
  actif: number;
  service_nom?: string;
}

interface CategoriesSpeTabProps {
  t: (key: string) => string;
  loading: boolean;
  services: Service[];
  categoriesSpecialite: CategoriesSpeItem[];
  newCategorieSpeNom: string;
  setNewCategorieSpeNom: React.Dispatch<React.SetStateAction<string>>;
  newCategorieSpeServiceId: number;
  setNewCategorieSpeServiceId: React.Dispatch<React.SetStateAction<number>>;
  creatingCategorieSpe: boolean;
  handleCreateCategorieSpe: () => void;
}

const CategoriesSpeTab: React.FC<CategoriesSpeTabProps> = ({
  t,
  loading,
  services,
  categoriesSpecialite,
  newCategorieSpeNom,
  setNewCategorieSpeNom,
  newCategorieSpeServiceId,
  setNewCategorieSpeServiceId,
  creatingCategorieSpe,
  handleCreateCategorieSpe,
}) => (
                  <div className="space-y-6">
                    <div>
                      <h2 className="text-lg font-semibold text-white mb-3">{t('categoriesSpe.addTitle')}</h2>
                      <p className="text-sm text-gray-400 mb-2">{t('categoriesSpe.addDescription')}</p>
                      <div className="flex flex-col sm:flex-row gap-3 flex-wrap">
                        <input
                          type="text"
                          value={newCategorieSpeNom}
                          onChange={(e) => setNewCategorieSpeNom(e.target.value)}
                          placeholder={t('categoriesSpe.placeholder')}
                          className="flex-1 min-w-[200px] px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500"
                        />
                        <select
                          value={newCategorieSpeServiceId || ''}
                          onChange={(e) => setNewCategorieSpeServiceId(Number(e.target.value))}
                          className="px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white min-w-[180px]"
                        >
                          <option value={0}>— {t('categoriesSpe.selectService')} —</option>
                          {services.map((s) => (
                            <option key={s.id} value={s.id}>{s.nom}</option>
                          ))}
                        </select>
                        <button
                          type="button"
                          onClick={handleCreateCategorieSpe}
                          disabled={creatingCategorieSpe}
                          className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg font-semibold transition-colors disabled:opacity-60"
                        >
                          {creatingCategorieSpe ? t('categoriesSpe.adding') : t('categoriesSpe.add')}
                        </button>
                      </div>
                    </div>
                    <div className="border-t border-gray-700 pt-4">
                      <h2 className="text-lg font-semibold text-white mb-3">{t('categoriesSpe.listTitle')}</h2>
                      {loading ? (
                        <p className="text-sm text-gray-500">{t('categoriesSpe.loading')}</p>
                      ) : categoriesSpecialite.length === 0 ? (
                        <p className="text-sm text-gray-500">{t('categoriesSpe.empty')}</p>
                      ) : (
                        <ul className="divide-y divide-gray-800">
                          {[...categoriesSpecialite].sort((a, b) => a.nom.localeCompare(b.nom, 'fr')).map((c) => (
                            <li key={c.id} className="py-2 flex justify-between text-gray-200">
                              <span>{c.nom}{c.service_nom ? ` (${c.service_nom})` : ''}</span>
                              <span className="text-xs text-gray-500">ID: {c.id}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
);

export default CategoriesSpeTab;
